const MILEAGE_OPTIONS = ['6000', '8000', '10000', '12000', '15000', '20000', '25000', '30000'];
const CONTRACT_LENGTH = ['24', '36', '48', '60'];
const INITIAL_PAYMENT_MULTIPLIER = ['1', '3', '6', '9', '12'];
export const deconstructLeaseTerms = (leaseOption) => {
    const LEASE_OPTION_PARTS = new RegExp(`^(${INITIAL_PAYMENT_MULTIPLIER.join('|')})_(${CONTRACT_LENGTH.join('|')})_(${MILEAGE_OPTIONS.join('|')})$`);
    if (!LEASE_OPTION_PARTS.test(leaseOption))
        return;
    const parts = leaseOption.split('_');
    return {
        depositMultiple: Number.parseInt(parts[0]),
        numberOfMonths: Number.parseInt(parts[1]),
        mileage: Number.parseInt(parts[2]),
    };
};
export const constructLeaseOption = (leaseOptionParts) => {
    return `${leaseOptionParts.depositMultiple}_${leaseOptionParts.numberOfMonths}_${leaseOptionParts.mileage}`;
};
export const isValidLeaseOptionString = (leaseOption) => {
    // allowed formats are 'cheapest' and 'N(N)_NN_NNNN(N) given N digits are allowed in list
    if (leaseOption === 'cheapest')
        return true;
    const parts = leaseOption.split('_');
    if (!INITIAL_PAYMENT_MULTIPLIER.includes(parts[0])) {
        return false;
    }
    if (!CONTRACT_LENGTH.includes(parts[1])) {
        return false;
    }
    return MILEAGE_OPTIONS.includes(parts[2]);
};
